export default "__VITE_ASSET__f9ca09e6__"